import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { HeaderRegister } from "../../components/HeaderRegister";
import { EquipmentService } from "../../services/equipment.service";
import { useEffect, useRef, useState } from "react";
import { ToastService } from "../../services/toast.service";
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from "react-router-dom";
import { FieldArray, Formik } from "formik";
import * as yup from 'yup';
import TransporterService from "../../services/transporter.service";
import { TransporterModel } from "../../models/transporter.model";
import { BranchModel } from "../../models/branch.model";
import { EquipmentFilhoModel } from "../../models/equipment.model";
import _ from 'lodash';
import BranchService from "../../services/branch.service";
import { LocaleModel } from "../../models/locale.model";
import LocaleService from "../../services/locale.service";
import PredictionModelService from "../../services/predictionModel.service";
import { PredictionModelModel } from "../../models/predictionModel.model";
import PredictionModelConfigService from "../../services/predictionModelConfig.service";
import { PredictionModelConfigModel } from "../../models/predictionModelConfig.model";
import EquipmentConfigService from "../../services/equipmentConfig.service";
import { FormDynamicControl } from "../../components/FormDynamicControl";
import { ColorPicker } from "../../components/ColorPicker";
import UtilService from "../../services/util.service";
import { DatasetModel } from "../../models/dataset.model";
import { DatasetDefault } from '../../models/dataset.model';
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from '../../models/requestInputOutputParams.model';
import { EquipmentHistoryModal } from "./history/modal";
import DatePicker from "react-datepicker";

//Sprint 22 - 7728 - Adicionar na Tela de Equipamentos - Status do Equipamento
import { EquipmentStatusModel } from "../../models/equipmentStatus.model";
import EquipmentStatusService from "../../services/equipmentStatus.service";
import { AddressCountryModel } from "../../models/addressCountry.model";
import { AddressStateModel } from "../../models/addressState.model";
import { AddressCityModel } from "../../models/addressCity.model";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion, faClock } from '@fortawesome/free-regular-svg-icons';
//Sprint 22 - 7728 - Adicionar na Tela de Equipamentos - Status do Equipamento
import styled from 'styled-components';
import storageService from "../../services/storage.service";
import TooltipDescriptionService from "../../services/tooltipDescription.service";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import EquipmentPickupHistoryService from "../../services/equipmentPickupHistory.service";
import moment from "moment";
import CustomDatePicker from "../../components/CustomDatePicker";

/**
 * Sprint3200
 * Ajustes para mudar o visual do tooltip,
 * para atender a demanada nova
 */
const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;

  &:hover .tooltip-content {
    visibility: visible;
    opacity: 1;
  }
`;

const TooltipContent = styled.div`
  visibility: hidden;
  width: 350px;
  background-color: white;
  color: black;
  text-align: left;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ddd;
  position: absolute;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s, transform 0.3s;

  &.adjust-left {
    left: auto;
    right: 0;
    transform: translateX(10px);
  }

  &.adjust-right {
    left: 0;
    transform: translateX(-10px);
  }

  &.adjust-top {
    bottom: calc(100% + 10px);
    transform: translateY(-10px);
  }

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent white transparent;

    &.adjust-left {
      left: auto;
      right: 10px;
      transform: translateX(0);
    }

    &.adjust-right {
      left: 10px;
      transform: translateX(0);
    }

    &.adjust-top {
      bottom: 100%;
      top: auto;
      border-color: white transparent transparent transparent;
    }
  }

  hr {
    border: 1px solid #ddd;
    margin: 8px 0;
  }

  .description {
    color: blue;
  }
`;

export const EquipmentRegister = () => {

  const [equipmentList, setEquipmentList] = useState<EquipmentFilhoModel[]>([]);

  const { id } = useParams<{ id?: string }>();
  const [initialValues, setInitialValues] = useState({
    idEquipment: 0,
    codeEquipment: '',
    localeId: undefined,
    transporterId: undefined,
    branchId: undefined,
    addressCountryId: undefined,
    addressStateId: undefined,
    addressCityId: undefined,
    predictionModelId: undefined,
    addressZipcode: '',
    addressStreet: '',
    addressNumber: '',
    addressAdjunct: '',
    addressCity: '',
    addressState: '',
    addressCountry: '',
    addressCoordinates: '',
    multiclientQuantity: 0,
    observation: '',
    worksOnMonday: '1',
    worksOnTuesday: '1',
    worksOnWednesday: '1',
    worksOnThursday: '1',
    worksOnFriday: '1',
    worksOnSunday: '1',
    worksOnSaturday: '1',
    equipmentConfig: [],
    clientComercialName: '',
    indicadorMulticlienteString: 'false',
    indicadorMulticliente: false,
    parentEquipmentIdList: [],
    equipmentStatusId: undefined, //Sprint 22 - 7728 - Adicionar na Tela de Equipamentos - Status do Equipamento
    equipmentStatus: '',          //Sprint 22 - 7728 - Adicionar na Tela de Equipamentos - Status do Equipamento
    equipmentOnlineLastReadDate: '',
    lastPickupDateByCashChangeDelivery: ''
  });
  const [isLoading, setLoading] = useState(false);
  const [parentEquipmentId, setParentEquipmentId] = useState(false);
  const [showMultiClient, setShowMultiClient] = useState(false);

  const { t } = useTranslation();
  const formRef = useRef();
  const history = useHistory();
  const [transporters, setTransporters] = useState<TransporterModel[]>();
  const [branches, setBranches] = useState<BranchModel[]>();
  const [countries, setCountries] = useState<AddressCountryModel[]>();
  const [states, setStates] = useState<AddressStateModel[]>();
  const [cities, setCities] = useState<AddressCityModel[]>();
  const [locales, setLocales] = useState<LocaleModel[]>();
  const [predictionModels, setPredictionModels] = useState<PredictionModelModel[]>();

  const [equipmentStatusModels, setEquipmentStatusModels] = useState<EquipmentStatusModel[]>(); //Sprint 22 - 7728 - Adicionar na Tela de Equipamentos - Status do Equipamento
  const user = storageService.getUser();
  const [tooltipDescription, setTooltipDescription] = useState<string>('');
  const tooltipRef = useRef(null);
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const [adjustTooltipClass, setAdjustTooltipClass] = useState('');

  //console.log("user", user)
  // - BEGIN MODAL HISTORY
  const [showHistoryModal, setShowHistoryModal] = useState({
    show: false
  });

  const fetchTooltipDescription = async (fieldId) => {
    try {
      const storedTooltip = localStorage.getItem(`tooltip_${fieldId}_${user.localeId}`);
      if (storedTooltip) {
        const { tooltipDescription: storedDescription } = JSON.parse(storedTooltip);
        setTooltipDescription(storedDescription);
      } else {
        const resp = await TooltipDescriptionService.GetByFieldLocale(fieldId, user.localeId);
        if (resp['success']) {
          const newDescription = resp['result'];
          setTooltipDescription(newDescription);
          localStorage.setItem(`tooltip_${fieldId}_${user.localeId}`, JSON.stringify({ tooltipDescription: newDescription }));
        } else {
          console.error("Erro ao obter a descrição do Tooltip:", resp && resp['messages']);
          setTooltipDescription('');
        }
      }
    } catch (error) {
      console.error("Erro na requisição do Tooltip:", error);
      setTooltipDescription('');
    }
  };

  const adjustTooltipPosition = () => {
    if (tooltipRef.current) {
      const tooltip = tooltipRef.current;
      const tooltipRect = tooltip.getBoundingClientRect();
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      let newClass = '';

      // Check if the tooltip is out of the viewport horizontally
      if (tooltipRect.right > screenWidth) {
        newClass += ' adjust-left';
        //console.log("Tooltip está saindo da tela à direita. Ajustando para a esquerda.");
      } else if (tooltipRect.left < 0) {
        newClass += ' adjust-right';
        //console.log("Tooltip está saindo da tela à esquerda. Ajustando para a direita.");
      }

      // Check if the tooltip is out of the viewport vertically
      if (tooltipRect.bottom > screenHeight) {
        newClass += ' adjust-top';
        //console.log("Tooltip está saindo da tela na parte inferior. Ajustando para cima.");
      }

      setAdjustTooltipClass(newClass.trim());
    }
  };

  useEffect(() => {
    if (isTooltipVisible) {
      adjustTooltipPosition();
    }
  }, [isTooltipVisible]);

  const actionShowHistoryModal = () => {
    setShowHistoryModal({ show: true });
  };

  const handleCloseHistoryModal = () => setShowHistoryModal({ show: false });

  // - END MODAL

  const onSubmit = async (data) => {

    if (Number(id)) {
      await update(data);
    } else {
      if (showMultiClient && (!data.multiclientQuantity || data.multiclientQuantity <= 0))
        ToastService.error(t('EQUIPMENT.INFORM_MULTICLIENT_QUANTITY'));
      else
        await create(data);
    }
  };

  const create = async (data) => {

    const payload = {
      ...JSON.parse(JSON.stringify(DatasetDefault)),
      dataset: 'equipment',
      data: [data],
    };

    let reqData: RequestInputOutputParamsModel = {
      ...RequestInputOutputParamsModelDefault,
      datasets: [payload],
    };

    try {
      setLoading(true);
      EquipmentService.insert(reqData)
        .then((response: any) => {
          if (response.success) {
            ToastService.success(t('EQUIPMENT.INSERTED'));
            history.push(`/Equipment`);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      ToastService.error(t('ERROR_GENERIC'));
    }



  };

  const update = async (data) => {

    data.parentEquipmentIdList = [];

    equipmentList.forEach(element => {
      if (element.isSelected) {
        data.parentEquipmentIdList.push(element.equipmentId)
      }
    });

    const payload = {
      ...JSON.parse(JSON.stringify(DatasetDefault)),
      dataset: 'equipment',
      data: [data],
    };

    let reqData: RequestInputOutputParamsModel = {
      ...RequestInputOutputParamsModelDefault,
      datasets: [payload],
    };

    try {
      setLoading(true);
      data.id = Number(id);
      EquipmentService.update(reqData)
        .then((response: any) => {
          if (
            response.result != null &&
            response.result.message_type != null &&
            response.result.message_type == "WARNING"
          ) {
            ToastService.success(t('EQUIPMENT.UPDATED'));
            ToastService.warn(t(response.result.message_code), null);
            history.push(`/Equipment`);
          } else {
            if (response.result != null) {
              ToastService.success(t('EQUIPMENT.UPDATED'));
              history.push(`/Equipment`);
            }
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      ToastService.error(t('ERROR_GENERIC'));
    }
  };

  const [imposedCollectionConfig, setImposedCollectionConfig] = useState(null);
  const initialize = async () => {
    setLoading(true);

    const user = storageService.getUser();
    setLocales([user.locale]);

    await TransporterService.getAll().then(async (response: any) => {
      if (response.success === true && response.result) {
        let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'transporter' }));
        const sort = (d?.data ?? []).sort((a, b) => a.fullName.localeCompare(b.fullName));
        setTransporters(sort);
      }
      else {
        setTransporters([]);
      }
    });

    await BranchService.getAll().then(async (response: any) => {
      if (response.success) {
        let branchList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'branch' });
       const sort = (branchList?.[0]?.data ?? []).sort((a, b) => a.fullName.localeCompare(b.fullName));
        setBranches(sort);
      } else {
        setBranches([]);
      }
    });

    await LocaleService.getAllCountries().then(async (response: any) => {
      if (response.success) {
        let branchList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'countries' });
        setCountries(branchList[0].data);
      } else {
        setCountries([]);
      }
    });

    await PredictionModelService.getAll().then((response: any) => {
      setPredictionModels(response.result);
    });

    let statusList = null;
    //Sprint 22 - 7728 - Adicionar na Tela de Equipamentos - Status do Equipamento
    await EquipmentStatusService.getAll().then((response: any) => {
      if (!Number(id)) {
        setEquipmentStatusModels(response.result.filter(x => x.id == 2));
        initialValues.equipmentStatusId = 2;
        // Usando setState para atualizar os valores iniciais
        setInitialValues(prevValues => ({
          ...prevValues,
          equipmentStatusId: 2
        }));
      }
      else
        statusList = response.result;
    });

    if (Number(id)) {
      const response: any = await EquipmentService.getById(id);

      try {
        if (response) {
          if (response.result) {
            let equipment = response.result;

            if (equipment.addressCountryId) {
              await LocaleService.getAllStates(equipment.addressCountryId).then(async (response: any) => {
                if (response.success) {
                  let branchList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'states' });
                  setStates(branchList[0].data);
                } else {
                  setStates([]);
                }
              });
            }

            if (equipment.addressStateId) {
              await LocaleService.getAllCities(equipment.addressStateId).then(async (response: any) => {
                if (response.success) {
                  let branchList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'cities' });
                  setCities(branchList[0].data);
                } else {
                  setCities([]);
                }
              });
            }

            if (equipment.parentEquipmentId === null) {
              setParentEquipmentId(true)
            }
            else {
              setParentEquipmentId(false)
            }

            if (equipment.indicadorMulticliente) {
              const responseEquipment: any = await EquipmentService.getAllByEquipmentCode(equipment.codeEquipment);

              if (responseEquipment && responseEquipment.result) {
                setEquipmentList(responseEquipment.result);
              }

              equipment.indicadorMulticlienteString = "true";
              equipment.indicadorMulticliente = true;
            }
            else {
              equipment.indicadorMulticlienteString = "false";
              equipment.indicadorMulticliente = false;
            }

            // GetByEquipment
            EquipmentConfigService.getByEquipment(equipment.id).then((resp: any) => {

                // Verifica se resp.result é nulo, indefinido ou vazio
              if (Array.isArray(resp?.result) && resp.result.length > 0) {
                const orderedConfigList = getOrdenedConfigList(resp.result);
                equipment.equipmentConfig = orderedConfigList;

                // Captura a configuração específica
                const imposedConfig = orderedConfigList.find(
                  config => config.configKey === "imposed_collection_by_cash_change_delivery"
                );

                // Atualiza o estado com o valor encontrado (ou null caso não exista)
                setImposedCollectionConfig(imposedConfig?.configValue ?? null);
              } else {
                equipment.equipmentConfig = []; // opcional: define um fallback vazio
                setImposedCollectionConfig(null); // garante estado limpo
              }
           

              setInitialValues(equipment);
              if (equipment.equipmentStatusId == 2) {
                setEquipmentStatusModels(statusList.filter(x => x.id == 2));
              }

              else
                setEquipmentStatusModels(statusList.filter(x => x.id != 2));
            });
          }
        }
      } catch (error) {
        ToastService.error(t('ERROR_GENERIC'));
      } finally {
        setLoading(false);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    initialize();
  }, []);

  const getOrdenedConfigList = (list) => {

    //list = list.filter(x => x.isEquipmentConfig === true);

    // Pegar as descrições da tradução atual
    list.map((item) => {
      return item.configDescription = t('CONFIG.' + item.configKey.toUpperCase()).toString().trimEnd();
    });

    // Ordenar a lista
    list.sort((a, b) => {
      const nameA = a.configDescription.toUpperCase(); // ignore upper and lowercase
      const nameB = b.configDescription.toUpperCase(); // ignore upper and lowercase

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });



    //  Deixar os 3 valores por primeiro    

    const monetary_limit = list.find(x => x.configKey.toLowerCase() == 'monetary_limit');
    const monetary_limit_index = list.findIndex(x => x.configKey.toLowerCase() == 'monetary_limit');
    list.splice(monetary_limit_index, 1);

    const limit_contractual = list.find(x => x.configKey.toLowerCase() == 'limit_contractual');
    const limit_contractual_index = list.findIndex(x => x.configKey.toLowerCase() == 'limit_contractual');
    list.splice(limit_contractual_index, 1);

    const physical_limit = list.find(x => x.configKey.toLowerCase() == 'physical_limit');
    const physical_limit_index = list.findIndex(x => x.configKey.toLowerCase() == 'physical_limit');
    list.splice(physical_limit_index, 1);

    const limit_contractual_original = list.find(x=>x.configKey.toLowerCase() == 'limit_contractual_original');
    const limit_contractual_original_index = list.findIndex(x=>x.configKey.toLowerCase() == 'limit_contractual_original');
    list.splice(limit_contractual_original_index,1);

    list.unshift(limit_contractual_original);
    list.unshift(physical_limit);
    list.unshift(limit_contractual);
    list.unshift(monetary_limit);

    return list;

  }

  const schema = yup.object().shape({
    // Validação para ver se o campo não é vazio, se for, mostrar mensagem de campo obrigatório
    codeEquipment: yup.string().trim().required(t('REQUIRED')).test(
      'isNotEmptyOrSpaces',
      t('REQUIRED'),
      (value) => {
        return !!value && value.trim() !== ''; // Verifica se o valor não está vazio ou contém apenas espaços
      }
    ),
    localeId: yup.string().required(t('REQUIRED')),
    branchId: yup.string().required(t('REQUIRED')),
    transporterId: yup.string().required(t('REQUIRED')),
    predictionModelId: yup.string().required(t('REQUIRED')),
    //addressZipcode: yup.string().required(t('REQUIRED')),
    //addressStreet: yup.string().required(t('REQUIRED')),
    //addressNumber: yup.string().required(t('REQUIRED')),
    addressCityId: yup.string().required(t('REQUIRED')),
    addressStateId: yup.string().required(t('REQUIRED')),
    addressCountryId: yup.string().required(t('REQUIRED')),
    equipmentStatusId: yup.string().required(t('REQUIRED')),

    // equipmentConfig: yup.array().of(
    //   yup.object().shape({
    //     configValue: yup.string().required(t('REQUIRED')),
    //   })
    // )

  });

  const handleChangeColor = (evt: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.color = evt.hex;
      }
    });
  }

  const handleChangeDate = (evt: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.formatDate(evt, "yyyy-MM-dd")
      }
    });
  }

  const handleChangeDateTime = (evt: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.formatDateTime(evt, "yyyy-MM-DD HH:mm:ss")
      }
    });
  }

  const handleChangeNumberRange = (valorInicio: any, valorFim: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.onlyNumber(valorInicio) + "|" + UtilService.onlyNumber(valorFim);
      }
    });
  }

  const handleChangeMoney = (evt: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.formatNumber(evt);
      }
    });
  }

  const handleChangeMoneyRange = (valorInicio: any, valorFim: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.formatNumber(valorInicio) + "|" + UtilService.formatNumber(valorFim);
      }
    });
  }

  const handleChangeDateRange = (dataInicio: any, dataFim: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.formatDate(dataInicio, "yyyy-MM-dd") + "|" + UtilService.formatDate(dataFim, "yyyy-MM-dd");
      }
    });
  }

  const handleChangeNumber = (evt: any, index: number, data: any) => {
    data.equipmentConfig.forEach(elemento => {
      if (index === elemento.id) {
        elemento.configValue = UtilService.onlyNumber(evt);
      }
    });
  }

  const submitFormik = () => {
    if (formRef && formRef.current) {
      let current: any = formRef.current;
      current.handleSubmit();
    }
  }

  const returnDisplay = (valueDatatype: string) => {
    if (valueDatatype == "D" || valueDatatype == "T" || valueDatatype == "B" || valueDatatype == "N" || valueDatatype == "I") {
      return "block";
    } else {
      return "none";
    }
  }

  function formatarDataBrasil(data) {
    // Verifica se a data está definida
    if (!data) return '';

    // Converte a data para objeto Date do JavaScript
    const dataObj = new Date(data);

    // Extrai dia, mês e ano
    const dia = dataObj.getDate().toString().padStart(2, '0');
    const mes = (dataObj.getMonth() + 1).toString().padStart(2, '0');
    const ano = dataObj.getFullYear();

    // Retorna a data formatada no formato DD/MM/AAAA
    return `${dia}/${mes}/${ano}`;
  }


  const [lastPickupDateCashChange, setLastPickupDateCashChange] = useState<string | null>(null);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const [editablePickupDate, setEditablePickupDate] = useState<string>('');

  useEffect(() => {
    const fetchLastPickupDateCashChange = async () => {
      if (id) {
        const response = await EquipmentPickupHistoryService.getLatestPickupCasheChangeDateByEquipment(Number(id));

        if (response.success && response.result) {
          setLastPickupDateCashChange(response.result);
          //console.log("Result", response.result)
          // Converte a data recebida para um objeto Date e define no DatePicker
          const parsedDate = moment(response.result, "YYYY-MM-DD");
          if (parsedDate.isValid()) {
            setSelectedDate(parsedDate.toDate());
          }
        } else {
          setLastPickupDateCashChange(null);
          setSelectedDate(null);
        }
      }
    };

    fetchLastPickupDateCashChange();
  }, [id]);



  const isDisabled = user.localeId !== 2;

  const renderReducedWeekDayReadableTime = (value: string | null) => {
    if (!value) return '';

    let formatDate = "DD/MM/YYYY"; // Garante que o ano tenha 4 dígitos
    let timezone = user.locale?.timeZone?.replace("UTC", "") ?? "0";

    return moment.utc(value).utcOffset(parseInt(timezone)).format(formatDate);
  };

  useEffect(() => {
    if (lastPickupDateCashChange) {
      setEditablePickupDate(renderReducedWeekDayReadableTime(lastPickupDateCashChange));
    }
  }, [lastPickupDateCashChange]);



  useEffect(() => {
    if (lastPickupDateCashChange) {
      const parsedDate = moment(lastPickupDateCashChange, "YYYY-MM-DD", true);
      if (parsedDate.isValid()) {
        setSelectedDate(parsedDate.toDate());
      }
    }
  }, [lastPickupDateCashChange]);

  //const [nextPickupDate, setNextPickupDate] = useState<string | null>(null); // Estado para armazenar a próxima data
  const [nextPickupDates, setNextPickupDates] = useState<string[]>([]); // Lista de próximas datas
  // Função para buscar e definir a próxima data
  // Função para buscar as próximas datas disponíveis
  const fetchNextPickupDates = async () => {
    try {
      const response = await EquipmentPickupHistoryService.GetNextPickupDatesByEquipment(Number(id));

      if (response.success && response.result.nextPickupDates?.length) {
        setNextPickupDates(response.result.nextPickupDates);
      } else {
        setNextPickupDates([]); // Se não houver próximas datas, esvazia a lista
      }
    } catch (error) {
      console.error("Erro ao buscar as próximas datas:", error);
      setNextPickupDates([]);
    }
  };

  // Chamar a função ao carregar o componente
  useEffect(() => {
    fetchNextPickupDates();
  }, [id]);


  // Função para definir a próxima data disponível ao clicar no botão
  const handleSetNextPickupDate = () => {
    if (nextPickupDates.length > 0) {
      const nextDate = nextPickupDates.shift(); // Pega a próxima data e remove da lista
      if (nextDate) {
        let parsedDate = moment(nextDate, moment.ISO_8601, true);

        // Verifica se o momento é válido
        if (!parsedDate.isValid()) {
          console.error("Data inválida recebida:", nextDate);
          return;
        }

        // Se a data não possuir horário, adicionar a hora atual no formato UTC
        if (parsedDate.format("HH:mm:ss") === "00:00:00") {
          parsedDate = parsedDate.utc().set({
            hour: moment.utc().hour(),
            minute: moment.utc().minute(),
            second: moment.utc().second(),
          });
        }

        setSelectedDate(parsedDate.toDate());
        setLastPickupDateCashChange(parsedDate.format("YYYY-MM-DD HH:mm:ss"));
        setNextPickupDates([...nextPickupDates]); // Atualiza a lista de datas
      }
    }
  };


  const [lastPickupDate, setLastPickupDate] = useState<string | null>(null);

  useEffect(() => {
    const fetchLatestPickupDate = async () => {
      if (id) {
        const response = await EquipmentPickupHistoryService.getLatestPickupDateByEquipmentFlagPickup(Number(id));

        if (response.success && response.result) {
          setLastPickupDate(response.result);

          const parsedDate = moment(response.result, "YYYY-MM-DDTHH:mm:ss");
          if (parsedDate.isValid()) {
            //setSelectedDate(parsedDate.toDate());
          }
        } else {
          setLastPickupDate(null);
          //setSelectedDate(null);
        }
      }
    };

    fetchLatestPickupDate();
  }, [id]); // Removido setValues das dependências

  // Converte o valor inicial para booleano
  const [imposedCollectionValue, setImposedCollectionValue] = useState(
    imposedCollectionConfig === "true" || imposedCollectionConfig === "1"
  );



  useEffect(() => {
    //console.log("Atualizando imposedCollectionValue:", imposedCollectionConfig);
    setImposedCollectionValue(imposedCollectionConfig === "true" || imposedCollectionConfig === "1");
  }, [imposedCollectionConfig]); // Atualiza sempre que imposedCollectionConfig mudar


  const [showModal, setShowModal] = useState(false);
  const [pendingSubmit, setPendingSubmit] = useState(false);
  const [submitValues, setSubmitValues] = useState(null);
  const [submitActions, setSubmitActions] = useState(null);

  const handleShowModal = (values, actions) => {
    setSubmitValues(values);
    setSubmitActions(actions);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);

    // Se a submissão estava pendente, continua
    if (pendingSubmit && submitValues && submitActions) {
      onSubmit(submitValues); // Chama a submissão real
      submitActions.setSubmitting(false);
      setPendingSubmit(false);
      setSubmitValues(null);
      setSubmitActions(null);
    }
  };

  const handleCancelModal = () => {
    setShowModal(false);
  }





  return (
    <>
      <HeaderRegister title={`${t('EQUIPMENT.TITLE')} | ${window.location.hash.includes("add") ? t("REGISTRATION") : t("EDITION")}`} path={"/Equipment"} submitForm={submitFormik} isLoading={isLoading || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} />

      <EquipmentHistoryModal
        id={id}
        title={t('HISTÓRICO DO EQUIPAMENTO')}
        close={handleCloseHistoryModal}
        cancel={t('CLOSE')}
        show={showHistoryModal ? showHistoryModal.show : false}
      >

      </EquipmentHistoryModal>
      {/* 🔥 Modal deve estar aqui fora da Formik para garantir que sempre seja renderizado */}
      <Modal show={showModal} onHide={handleCancelModal}>
        <Modal.Header closeButton>
          <Modal.Title>{t('WARNING')}</Modal.Title> {/* 🔥 Traduzindo o título do modal */}
        </Modal.Header>
        <Modal.Body>
          {t('DAYS_LESS_THAN_30_WARNING')} {/* 🔥 Traduzindo a mensagem do corpo do modal */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            {t('ACKNOWLEDGE')} {/* 🔥 Traduzindo o botão de fechar */}
          </Button>
        </Modal.Footer>
      </Modal>

      <Formik
        enableReinitialize={true}
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={(values, actions) => {

          let hasError = false;

          // ✅ Verifica a regra ANTES de enviar o formulário
          const daysWithoutCollect = values.equipmentConfig.find(
            (config) => config.configKey === "days_without_collect_by_cash_change_delivery"
          )?.configValue;

          //console.log("daysWithouCollect", daysWithoutCollect)

          const equipmentChangeRequired = values.equipmentConfig.find(
            (config) => config.configKey === "equipment_change_required"
          )?.configValue === "true"; // Convertendo para booleano

          //console.log("equipmentChangeRequired", equipmentChangeRequired)

          const sequenceForSendingChangeEmails = values.equipmentConfig.find(
            (config) => config.configKey === "sequence_for_sending_change_emails"
          )?.configValue;

          //console.log("sequenceForSendingChangeEmails", sequenceForSendingChangeEmails)

          const imposedCollectionByCashChange = values.equipmentConfig.find(
            (config) => config.configKey === "imposed_collection_by_cash_change_delivery"
          )?.configValue === "true"; // Convertendo para booleano
          
          //console.log("imposedCollectionByCashChange", imposedCollectionByCashChange);

          const isDaysLessThan30 = daysWithoutCollect && parseInt(daysWithoutCollect, 10) < 30;

          // Atualiza o campo com a data antes de enviar
          values.lastPickupDateByCashChangeDelivery = lastPickupDateCashChange
            ? moment(lastPickupDateCashChange, "YYYY-MM-DD HH:mm:ss", true).isValid()
              ? lastPickupDateCashChange
              : moment.utc(lastPickupDateCashChange, "YYYY-MM-DD").set({
                hour: moment.utc().hour(),
                minute: moment.utc().minute(),
                second: moment.utc().second(),
              }).format("YYYY-MM-DD HH:mm:ss")
            : "";

            values.equipmentConfig.forEach((element) => {
              // Verificação para last_read_date
              if (element.configKey === 'last_read_date' && !element.configValue) {
                ToastService.error(t('ERROR_SAVE_LAST_READ_DATE_EMPTY'));
                hasError = true;
              }
              // Verificação para monetary_limit
              if (element.configKey === 'monetary_limit') {
                const monetaryLimitValue = Number(element.configValue);
  
                if (monetaryLimitValue <= 0) {
                  ToastService.error(t('ERROR_SAVE_EQUIPMENT_MONETARY_ZERO'));
                  hasError = true;
                }
              }
              // Verificação para limit_contractual
              if (element.configKey === 'limit_contractual') {
                const limitContractualValue = Number(element.configValue);
                const monetaryLimitElement = values.equipmentConfig.find(config => config.configKey === 'monetary_limit');
                const monetaryLimitValue = monetaryLimitElement ? Number(monetaryLimitElement.configValue) : null;
  
                if (monetaryLimitValue !== null && limitContractualValue < monetaryLimitValue) {
                  ToastService.error(t('ERROR_SAVE_EQUIPMENT_MONETARY_BIGGER_CONTRACTUAL'));
                  hasError = true;
                }
              }
  
              // Formatar o valor da sequência se necessário
              element.configValue = element.configKey.startsWith('sequence')
                ? element.configValue.replace(/,{2,}/g, ',').replace(/^,|,$/g, '')
                : element.configValue;
            });

          // ✅ Se **TODAS AS CONDIÇÕES** forem verdadeiras, o modal aparece
          if (
            imposedCollectionByCashChange && 
            equipmentChangeRequired && 
            sequenceForSendingChangeEmails?.trim() && 
            isDaysLessThan30) {
            setPendingSubmit(true);
            handleShowModal(values, actions);
            return;
          }
          

          if (!hasError) {
            onSubmit(values);
          } else {
            actions.setSubmitting(false); // Para evitar o bloqueio do botão de envio
          }
        }}
      >

        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          setValues
        }) => (

          <Form noValidate onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} xl={12}>
                <Row className="align-items-center">
                  <Col sm={12} md={3} lg={2} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='localeId'
                          name='localeId'
                          isInvalid={touched.localeId && !!errors.localeId}
                          disabled={(Number(id)) ? true : false}
                          onChange={(event) => {
                            setValues(prevValues => ({
                              ...prevValues,
                              localeId: event.target.value,
                              transporterId: '',
                              branchId: ''
                            }))
                          }}
                          value={values.localeId}
                          aria-label={t("EQUIPMENT.LOCALE")}>
                          <option value="">{t("EQUIPMENT.LOCALE")}</option>
                          {_.map(locales, (l: LocaleModel) => {
                            return <option key={l.id} value={l.id}>{l.name}</option>
                          })}

                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.localeId}
                        </Form.Control.Feedback>
                        <label htmlFor="localeId">{t("EQUIPMENT.LOCALE")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={3} lg={2} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='transporterId'
                          name='transporterId'
                          isInvalid={touched.transporterId && !!errors.transporterId}
                          //disabled={(Number(id)) ? true : false}
                          onChange={(event) => {
                            setValues(prevValues => ({
                              ...prevValues,
                              transporterId: event.target.value,
                              branchId: undefined
                            }))
                          }}
                          value={values.transporterId}
                          aria-label={t("EQUIPMENT.TRANSPORTERNAME")}>
                          <option value="">{t("EQUIPMENT.TRANSPORTERNAME")}</option>
                          {_.map(_.filter(transporters, function (t) { return t.localeId.toString() === values.localeId?.toString() || values.localeId?.toString() === "0"; }), (l: TransporterModel) => {
                            return <option key={l.id} value={l.id}>{l.fullName}</option>
                          })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.transporterId}
                        </Form.Control.Feedback>
                        <label htmlFor="transporterId">{t("EQUIPMENT.TRANSPORTERNAME")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={3} lg={2} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='branchId'
                          name='branchId'
                          isInvalid={touched.branchId && !!errors.branchId}
                          onChange={handleChange}
                          value={values.branchId}
                          aria-label={t("EQUIPMENT.BRANCH")}>
                          <option value="">{t("EQUIPMENT.BRANCH")}</option>
                          {_.map(_.filter(branches, function (b) { return b.transporterId.toString() === values.transporterId?.toString(); }), (l: BranchModel) => {
                            return <option key={l.id} value={l.id}>{l.fullName}</option>
                          })}

                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.branchId}
                        </Form.Control.Feedback>
                        <label htmlFor="branchId">{t("EQUIPMENT.BRANCH")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={3} lg={2} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='predictionModelId'
                          name='predictionModelId'
                          isInvalid={touched.predictionModelId && !!errors.predictionModelId}
                          disabled={isLoading}
                          onChange={(event) => {
                            let value = event.target.value;
                            if (value) {
                              PredictionModelConfigService.getByPredictionModelOnlyConfigs(event.target.value).then((response: any) => {

                               setValues(prevValues => ({
                                  ...prevValues,
                                  equipmentConfig: []   // limpa lista completamente
                                }));

                                const list = getOrdenedConfigList(response.result);

                                setValues(prevValues => ({
                                  ...prevValues,
                                  predictionModelId: value,
                                  equipmentConfig: list.map(i => {
                                    return { ...i, equipmentId: id }
                                  })
                                }))
                              });
                            } else {
                              setValues(prevValues => ({
                                ...prevValues,
                                predictionModelId: value,
                                equipmentConfig: []
                              }))
                            }
                          }}
                          value={values.predictionModelId}
                          aria-label={t("EQUIPMENT.MODEL")}>
                          <option value=''>{t("EQUIPMENT.MODEL")}</option>
                          {_.map(predictionModels, (l: PredictionModelModel) => {
                            return <option key={l.id} value={l.id}>{l.localeId == 0 ? t("PREDICTIONMODEL." + l.fullName.toUpperCase()) : l.fullName}</option>
                          })}

                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.predictionModelId}
                        </Form.Control.Feedback>
                        <label htmlFor="predictionModelId">{t("EQUIPMENT.MODEL")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='codeEquipment'
                          id='codeEquipment'
                          type='text'
                          placeholder={t('EQUIPMENT.CODE_EQUIPMENT')}
                          onKeyDown={(event) => {
                            if (event.key === ';') {
                              event.preventDefault();
                            }
                          }}                          
                          onChange={(event) => {
                            const sanitizedValue = event.target.value.replace(/;/g, '');
                            //console.log("Event de change ", equipmentStatusModels)
                            setValues(prevValues => {
                              //console.log("PrevValues (onChange):", prevValues);
                              return {
                                ...prevValues,
                                "codeEquipment": sanitizedValue,
                              };
                            });
                          }}
                          onBlur={(event) => {
                            if (event.target.value == '') {

                              setValues(prevValues => ({
                                ...prevValues,
                                indicadorMulticlienteString: 'false',
                                indicadorMulticliente: false
                              }));

                              setEquipmentList([]);
                            }
                          }}
                          disabled={isLoading ? true : (Number(id) ? true : false)}
                          isInvalid={touched.codeEquipment && !!errors.codeEquipment}
                          value={values.codeEquipment}
                          maxLength={50}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.codeEquipment}
                        </Form.Control.Feedback>
                        <Form.Label>{t('EQUIPMENT.CODE_EQUIPMENT')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col sm={4} md={4} lg={4} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='clientComercialName'
                          id='clientComercialName'
                          type='text'
                          placeholder={t('EQUIPMENT.CLIENT_COMERCIAL_NAME')}
                          onKeyDown={(event) => {
                            if (event.key === ';') {
                              event.preventDefault();
                            }
                          }}
                          onChange={(event) => {
                            const sanitizedValue = event.target.value.replace(/;/g, '');
                            setValues(prevValues => {
                              return {
                                ...prevValues,
                                "clientComercialName": sanitizedValue,
                              };
                            });
                          }}                          
                          //onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.clientComercialName && !!errors.clientComercialName}
                          value={values.clientComercialName}
                          maxLength={250}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.clientComercialName}
                        </Form.Control.Feedback>
                        <Form.Label>{t('EQUIPMENT.CLIENT_COMERCIAL_NAME')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={6} lg={2} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='addressZipcode'
                          id='addressZipcode'
                          type='text'
                          placeholder={t('EQUIPMENT.ADDRESS_ZIPCODE')}
                          onKeyDown={(event) => {
                            if (event.key === ';') {
                              event.preventDefault();
                            }
                          }}
                          onChange={(event) => {
                            const sanitizedValue = event.target.value.replace(/;/g, '');
                            setValues(prevValues => {
                              return {
                                ...prevValues,
                                "addressZipcode": sanitizedValue,
                              };
                            });
                          }}                            
                          //onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.addressZipcode && !!errors.addressZipcode}
                          value={values.addressZipcode}
                          maxLength={10}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.addressZipcode}
                        </Form.Control.Feedback>
                        <Form.Label>{t('EQUIPMENT.ADDRESS_ZIPCODE')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={6} lg={5} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='addressStreet'
                          id='addressStreet'
                          type='text'
                          placeholder={t('EQUIPMENT.ADDRESS_STREET')}
                          onKeyDown={(event) => {
                            if (event.key === ';') {
                              event.preventDefault();
                            }
                          }}
                          onChange={(event) => {
                            const sanitizedValue = event.target.value.replace(/;/g, '');
                            setValues(prevValues => {
                              return {
                                ...prevValues,
                                "addressStreet": sanitizedValue,
                              };
                            });
                          }}                              
                          //onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.addressStreet && !!errors.addressStreet}
                          value={values.addressStreet}
                          maxLength={100}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.addressStreet}
                        </Form.Control.Feedback>
                        <Form.Label>{t('EQUIPMENT.ADDRESS_STREET')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>

                  <Col sm={12} md={6} lg={2} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='addressNumber'
                          id='addressNumber'
                          type='text'
                          placeholder={t('EQUIPMENT.ADDRESS_NUMBER')}
                          onKeyDown={(event) => {
                            if (event.key === ';') {
                              event.preventDefault();
                            }
                          }}
                          onChange={(event) => {
                            const sanitizedValue = event.target.value.replace(/;/g, '');
                            setValues(prevValues => {
                              return {
                                ...prevValues,
                                "addressNumber": sanitizedValue,
                              };
                            });
                          }}                           
                          //onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.addressNumber && !!errors.addressNumber}
                          value={values.addressNumber}
                          maxLength={20}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.addressNumber}
                        </Form.Control.Feedback>
                        <Form.Label>{t('EQUIPMENT.ADDRESS_NUMBER')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='addressAdjunct'
                          id='addressAdjunct'
                          type='text'
                          placeholder={t('EQUIPMENT.ADDRESS_ADJUNCT')}
                          onKeyDown={(event) => {
                            if (event.key === ';') {
                              event.preventDefault();
                            }
                          }}
                          onChange={(event) => {
                            const sanitizedValue = event.target.value.replace(/;/g, '');
                            setValues(prevValues => {
                              return {
                                ...prevValues,
                                "addressAdjunct": sanitizedValue,
                              };
                            });
                          }}                          
                          //onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.addressAdjunct && !!errors.addressAdjunct}
                          value={values.addressAdjunct}
                          maxLength={100}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.addressAdjunct}
                        </Form.Control.Feedback>
                        <Form.Label>{t('EQUIPMENT.ADDRESS_ADJUNCT')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={3} lg={2} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='addressCountry'
                          id='addressCountry'
                          type='hidden'
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.addressCountry && !!errors.addressCountry}
                          value={values.addressCountry}
                          maxLength={100}
                        />
                        <Form.Select
                          id='addressCountryId'
                          name='addressCountryId'
                          isInvalid={touched.addressCountryId && !!errors.addressCountryId}
                          //onChange={handleChange}
                          onChange={(event) => {
                            setValues(prevValues => ({
                              ...prevValues,
                              addressCountryId: event.target.value,
                              addressStateId: undefined,
                              addressCityId: undefined
                            }));
                            setCities([]);
                            setStates([]);
                            if (event.target.value) {
                              LocaleService.getAllStates(event.target.value).then(async (response: any) => {
                                if (response.success) {
                                  let branchList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'states' });
                                  setStates(branchList[0].data);
                                } else {
                                  setStates([]);
                                }
                              });
                            }
                          }}
                          value={values.addressCountryId}
                          aria-label={t("EQUIPMENT.COUNTRY")}>
                          <option value="">{t("EQUIPMENT.COUNTRY")}</option>
                          {_.map(countries, (l: AddressCountryModel) => {
                            return <option key={l.id_address_country} value={l.id_address_country}>{l.name}</option>
                          })}

                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.addressCountryId}
                        </Form.Control.Feedback>
                        <label htmlFor="addressCountryId">{t("EQUIPMENT.COUNTRY")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={3} lg={2} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='addressState'
                          id='addressState'
                          type='hidden'
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.addressState && !!errors.addressState}
                          value={values.addressState}
                          maxLength={100}
                        />
                        <Form.Select
                          id='addressStateId'
                          name='addressStateId'
                          isInvalid={touched.addressStateId && !!errors.addressStateId}
                          //onChange={handleChange}
                          onChange={(event) => {
                            setValues(prevValues => ({
                              ...prevValues,
                              addressStateId: event.target.value,
                              addressCityId: undefined
                            }));
                            setCities([]);
                            if (event.target.value) {
                              LocaleService.getAllCities(event.target.value).then(async (response: any) => {
                                if (response.success) {
                                  let branchList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'cities' });
                                  setCities(branchList[0].data);
                                } else {
                                  setCities([]);
                                }
                              });
                            }
                          }}
                          value={values.addressStateId}
                          aria-label={t("EQUIPMENT.STATE")}>
                          <option value="">{t("EQUIPMENT.STATE")}</option>
                          {_.map(states, (l: AddressStateModel) => {
                            return <option key={l.id_address_state} value={l.id_address_state}>{l.name}</option>
                          })}

                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.addressStateId}
                        </Form.Control.Feedback>
                        <label htmlFor="addressStateId">{t("EQUIPMENT.STATE")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={3} lg={2} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='addressCity'
                          id='addressCity'
                          type='hidden'
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.addressCity && !!errors.addressCity}
                          value={values.addressCity}
                          maxLength={100}
                        />
                        <Form.Select
                          id='addressCityId'
                          name='addressCityId'
                          isInvalid={touched.addressCityId && !!errors.addressCityId}
                          onChange={handleChange}
                          value={values.addressCityId}
                          aria-label={t("EQUIPMENT.CITY")}>
                          <option value="">{t("EQUIPMENT.CITY")}</option>
                          {_.map(cities, (l: AddressCityModel) => {
                            return <option key={l.id_address_city} value={l.id_address_city}>{l.name}</option>
                          })}

                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.addressCityId}
                        </Form.Control.Feedback>
                        <label htmlFor="addressCityId">{t("EQUIPMENT.CITY")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='addressCoordinates'
                          id='addressCoordinates'
                          type='text'
                          placeholder={t('EQUIPMENT.ADDRESS_COORDINATES')}
                          onKeyDown={(event) => {
                            if (event.key === ';') {
                              event.preventDefault();
                            }
                          }}
                          onChange={(event) => {
                            const sanitizedValue = event.target.value.replace(/;/g, '');
                            setValues(prevValues => {
                              return {
                                ...prevValues,
                                "addressCoordinates": sanitizedValue,
                              };
                            });
                          }}                            
                          //onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.addressCoordinates && !!errors.addressCoordinates}
                          value={values.addressCoordinates}
                          maxLength={30}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.addressCoordinates}
                        </Form.Control.Feedback>
                        <Form.Label>{t('EQUIPMENT.ADDRESS_COORDINATES')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={6} lg={6} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='observation'
                          id='observation'
                          as="textarea" rows={3}
                          placeholder={t('EQUIPMENT.OBSERVATION')}
                          onKeyDown={(event) => {
                            if (event.key === ';') {
                              event.preventDefault();
                            }
                          }}
                          onChange={(event) => {
                            const sanitizedValue = event.target.value.replace(/;/g, '');
                            setValues(prevValues => {
                              return {
                                ...prevValues,
                                "observation": sanitizedValue,
                              };
                            });
                          }}                             
                          //onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.observation && !!errors.observation}
                          value={values.observation}
                          maxLength={1000}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.observation}
                        </Form.Control.Feedback>
                        <Form.Label>{t('EQUIPMENT.OBSERVATION')}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  {/* Sprint 22 - 7728 - Adicionar na Tela de Equipamentos - Status do Equipamento */}

                  <Col sm={12} md={6} lg={2} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='equipmentStatusId'
                          name='equipmentStatusId'
                          isInvalid={touched.equipmentStatusId && !!errors.equipmentStatusId}
                          disabled={isLoading || equipmentStatusModels?.length <= 1}
                          onChange={(event) => {
                            let value = event.target.value;
                            if (value) {
                              EquipmentStatusService.getById(event.target.value).then((response: any) => {
                                setValues(prevValues => ({
                                  ...prevValues,
                                  equipmentStatusId: value,
                                  equipmentStatus: t('EQUIPMENT_STATUS.' + response.result.nickname.toUpperCase().toString().trimEnd())
                                }))
                              });
                            } else {
                              setValues(prevValues => ({
                                ...prevValues,
                                equipmentStatusId: value,
                                equipmentStatus: ''
                              }))
                            }
                          }}
                          value={equipmentStatusModels?.length > 1 ? values.equipmentStatusId : 2}
                          aria-label={t("EQUIPMENT.STATUS")}>
                          <option value=''>{t("EQUIPMENT.STATUS")}</option>
                          {_.map(equipmentStatusModels, (l: EquipmentStatusModel) => {
                            return <option key={l.id} value={l.id}>{t("EQUIPMENT_STATUS." + l.nickname.toUpperCase())}</option>
                          })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.equipmentStatusId}
                        </Form.Control.Feedback>
                        <label htmlFor="equipmentStatusId">{t("EQUIPMENT.STATUS")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={6} lg={3} className="mb-4">
                    <div className="d-flex align-items-center">
                      <Form.Group className="flex-grow-1 me-2">
                        <Form.Floating>
                          <Form.Control
                            name='equipLastOnlineDate'
                            id='equipLastOnlineDate'
                            type='text'
                            placeholder={t('EQUIPMENT.EQUIP_LAST_ONLINE_DATE')}
                            disabled={true}
                            value={formatarDataBrasil(values.equipmentOnlineLastReadDate)}
                            maxLength={30}
                          />
                          <Form.Label>{t('EQUIPMENT.EQUIP_LAST_ONLINE_DATE')}</Form.Label>
                        </Form.Floating>
                      </Form.Group>

                    </div>
                  </Col>

                  <Col sm={12} md={6} lg={3} className="mb-4">
                    <div className="d-flex align-items-center">
                      <Form.Group className="flex-grow-1 me-2">
                        <Form.Floating>
                          <Form.Control
                            name='equipPickupLastOnlineDate'
                            id='equipPickupLastOnlineDate'
                            type='text'
                            placeholder={t('EQUIPMENT.LAST_PICKUP_DATE')}
                            disabled={true}
                            value={formatarDataBrasil(lastPickupDate)} // Evita erro se não houver data
                            maxLength={30}
                          />
                          <Form.Label>{t('EQUIPMENT.LAST_PICKUP_DATE')}</Form.Label>
                        </Form.Floating>
                      </Form.Group>

                    </div>
                  </Col>

                  <Col sm={12} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <div className="d-flex align-items-center gap-2">
                        <CustomDatePicker
                          selectedDate={selectedDate}
                          onChange={(date) => {
                            if (!date) {
                              setSelectedDate(null);
                              setLastPickupDateCashChange(null);
                              return;
                            }

                            const parsedDate = moment(date);

                            // Bloqueia hoje e futuras
                            if (parsedDate.isAfter(moment(), "day")) {
                              console.error("Não é permitido selecionar datas futuras.");
                              return;
                            }

                            setSelectedDate(parsedDate.toDate());
                            setLastPickupDateCashChange(parsedDate.format("YYYY-MM-DDTHH:mm:ss")); // Inclui data e hora UTC
                          }}
                          label={t("EQUIPMENT.LAST_PICKUP_DATE_BY_CASH_CHANGE_DELIVERY")}
                          disabled={!imposedCollectionValue}
                        />

                        {/* Botão para definir a próxima data disponível */}
                        <Button
                          variant="link"
                          className="p-0 border-0 d-flex align-items-center"
                          onClick={handleSetNextPickupDate} // Agora seta a próxima data corretamente
                          disabled={!imposedCollectionValue || !id || nextPickupDates.length === 0} // Desabilita se não houver próximas datas
                          style={{ width: "38px", height: "37.5px", marginTop: "-8px", color: nextPickupDates.length > 0 ? "#0d6efd" : "#ccc" }} // Cinza quando desabilitado
                        >
                          <FontAwesomeIcon icon={faArrowLeft} size="lg" />
                        </Button>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={6} lg={3} className="mb-2">
                    <Button
                      variant="outline-primary"
                      onClick={actionShowHistoryModal}
                      disabled={!id}
                      style={{ height: "40px" }}
                    >
                      Histórico
                    </Button>
                  </Col>

                  {/* Sprint 22 - 7728 - Adicionar na Tela de Equipamentos - Status do Equipamento */}
                </Row>

                <Row>
                  <Col sm={3} md={3} lg={3}>
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>{t('BRANCH.DAYS_WORKS')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnMonday`}
                                name={`worksOnMonday`}
                                label={t('MONDAY')}
                                disabled={isLoading}
                                onChange={(event) => {
                                  setValues(prevValues => ({
                                    ...prevValues,
                                    [event.target.name]: (prevValues[event.target.name] === "1" ? "0" : "1")
                                  }))
                                }}
                                checked={values.worksOnMonday === '1'}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnTuesday`}
                                name={`worksOnTuesday`}
                                label={t('TUESDAY')}
                                disabled={isLoading}
                                onChange={(event) => {
                                  setValues(prevValues => ({
                                    ...prevValues,
                                    [event.target.name]: (prevValues[event.target.name] === "1" ? "0" : "1")
                                  }))
                                }}
                                checked={values.worksOnTuesday === '1'}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnWednesday`}
                                name={`worksOnWednesday`}
                                label={t('WEDNESDAY')}
                                disabled={isLoading}
                                onChange={(event) => {
                                  setValues(prevValues => ({
                                    ...prevValues,
                                    [event.target.name]: (prevValues[event.target.name] === "1" ? "0" : "1")
                                  }))
                                }}
                                checked={values.worksOnWednesday === '1'}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnThursday`}
                                name={`worksOnThursday`}
                                label={t('THURSDAY')}
                                disabled={isLoading}
                                onChange={(event) => {
                                  setValues(prevValues => ({
                                    ...prevValues,
                                    [event.target.name]: (prevValues[event.target.name] === "1" ? "0" : "1")
                                  }))
                                }}
                                checked={values.worksOnThursday === '1'}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnFriday`}
                                name={`worksOnFriday`}
                                label={t('FRIDAY')}
                                disabled={isLoading}
                                onChange={(event) => {
                                  setValues(prevValues => ({
                                    ...prevValues,
                                    [event.target.name]: (prevValues[event.target.name] === "1" ? "0" : "1")
                                  }))
                                }}
                                checked={values.worksOnFriday === '1'}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnSaturday`}
                                name={`worksOnSaturday`}
                                label={t('SATURDAY')}
                                disabled={isLoading}
                                onChange={(event) => {
                                  setValues(prevValues => ({
                                    ...prevValues,
                                    [event.target.name]: (prevValues[event.target.name] === "1" ? "0" : "1")
                                  }))
                                }}
                                checked={values.worksOnSaturday === '1'}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnSunday`}
                                name={`worksOnSunday`}
                                label={t('SUNDAY')}
                                disabled={isLoading}
                                onChange={(event) => {
                                  setValues(prevValues => ({
                                    ...prevValues,
                                    [event.target.name]: (prevValues[event.target.name] === "1" ? "0" : "1")
                                  }))
                                }}
                                checked={values.worksOnSunday === '1'}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>

                  {parentEquipmentId &&

                    <Col sm={3} md={3} lg={3} >
                      <Form.Group>
                        <Form.Label className="me-2">{t('EQUIPMENT.EQUIPMENT_MULTI_CLIENTE')}</Form.Label>

                        <Form.Check
                          inline
                          label={t('YES')}
                          disabled={true}
                          name='indicadorMulticlienteString'
                          type='radio'
                          value='true'
                          onChange={(event) => {

                            if (values.codeEquipment == '') {
                              ToastService.warn(t('EQUIPMENT.INFORM_CODEQUIPMENT'), null);
                              return;
                            }

                            setValues(prevValues => ({
                              ...prevValues,
                              indicadorMulticlienteString: 'true',
                              indicadorMulticliente: true
                            }));

                            EquipmentService.getAllByEquipmentCode(values.codeEquipment).then((response: any) => {
                              if (response && response.result) {
                                setEquipmentList(response.result);
                              }
                            });

                          }}

                          checked={values.indicadorMulticlienteString === 'true'}
                          feedback={
                            <Form.Control.Feedback type="invalid">
                              {errors.indicadorMulticlienteString}
                            </Form.Control.Feedback>
                          }
                        />

                        <Form.Check
                          inline
                          disabled={true}
                          label={t('NO')}
                          name='indicadorMulticlienteString'
                          type='radio'
                          checked={values.indicadorMulticlienteString === 'false'}
                          value='false'
                          onChange={(event) => {

                            setValues(prevValues => ({
                              ...prevValues,
                              indicadorMulticlienteString: 'false',
                              indicadorMulticliente: false
                            }));

                            setEquipmentList([]);

                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.indicadorMulticlienteString}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <FieldArray
                        name="selectedEquipment"
                        render={arrayHelpers => (
                          <>
                            {equipmentList.map((equipment, index) => {
                              return (
                                <div key={index}>
                                  <Form.Check type="checkbox"
                                    label={equipment.equipmentCode}
                                    name={'selectedEquipment'}
                                    disabled={true}
                                    checked={(equipmentList.find(x => x.equipmentId == equipment.equipmentId && x.isSelected == true) != null ? true : false)}
                                    onChange={e => {
                                      if (e.target.checked) {
                                        equipment.isSelected = true;
                                        arrayHelpers.push(equipment.equipmentId);
                                      } else {
                                        equipment.isSelected = false;
                                        arrayHelpers.remove(index);
                                      }
                                    }}
                                  />
                                </div>)
                            })}
                          </>
                        )}
                      />
                    </Col>
                  }
                  {!id && <>
                    <Col sm={12} md={6} lg={2} className="mb-4">
                      <Form.Group>
                        <Form.Check
                          inline
                          label={t('EQUIPMENT.MULTICLIENT')}
                          disabled={isLoading}
                          type='checkbox'
                          onChange={(event) => {
                            setValues(prevValues => ({
                              ...prevValues,
                              multiclientQuantity: 0
                            }));
                            setShowMultiClient(event.target.checked);
                          }}
                          checked={showMultiClient === true}
                        />
                      </Form.Group>
                    </Col>

                    {showMultiClient && <Col sm={12} md={4} lg={2} className="mb-4">
                      <Form.Group>
                        <Form.Floating>
                          <Form.Control
                            name='multiclientQuantity'
                            id='multiclientQuantity'
                            type='text'
                            placeholder={t('EQUIPMENT.MULTICLIENT_QUANTITY_LABEL')}
                            onChange={(event) => {
                              setValues(prevValues => ({
                                ...prevValues,
                                [event.target.name]: event.target.value.replace(/[^0-9]/, '')
                              }))
                            }}
                            onBlur={handleBlur}
                            disabled={isLoading || !showMultiClient}
                            isInvalid={touched.multiclientQuantity && !!errors.multiclientQuantity}
                            value={values.multiclientQuantity}
                            maxLength={30}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.multiclientQuantity}
                          </Form.Control.Feedback>
                          <Form.Label>{t('EQUIPMENT.MULTICLIENT_QUANTITY_LABEL')}</Form.Label>
                        </Form.Floating>
                      </Form.Group>
                    </Col>}</>}
                </Row>

                <Row className="align-items-center">
                  <h6>{t("EQUIPMENT.CONFIGS")}</h6>
                  <hr />
                  <FieldArray
                    name="equipmentConfig"
                    render={arrayHelpers => (
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(50px, 1fr))', gridGap: '1rem', width: 'fit-content' }}>
                        {values.equipmentConfig && values.equipmentConfig.length > 0 && (
                          _.orderBy(values.equipmentConfig, ['configKey'], ['asc'])
                            .map((ec, index) => (
                              <Row key={index}>
                                <Col xs={12} sm={6} md={6} lg={4} className="mb-4" style={{ display: 'flex' }}>
                                  <span className="pb-2" style={{ display: 'inline-block', alignSelf: 'flex-end', height: '40px' }}>
                                    {values.equipmentConfig[index].configDescription}
                                    <TooltipContainer
                                      key={index}
                                      onMouseOver={() => {
                                        fetchTooltipDescription(values.equipmentConfig[index].generalFieldTranslatorId);
                                        setTooltipVisible(true);
                                      }}
                                      onMouseOut={() => {
                                        setTooltipVisible(false);
                                        setAdjustTooltipClass('');
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faCircleQuestion} className="pt-2 pl-1" />
                                      <TooltipContent ref={tooltipRef} className={`tooltip-content ${adjustTooltipClass}`}>
                                        <strong>{values.equipmentConfig[index].configKey}</strong>
                                        <hr />
                                        <div className="description">
                                          {tooltipDescription ? tooltipDescription : t('LOADING_TOOLTIP_DESCRIPTION')}
                                        </div>
                                      </TooltipContent>
                                    </TooltipContainer>
                                  </span>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={4} className="mb-4">
                                  <Form.Group>
                                    <Form.Floating>
                                      <FormDynamicControl
                                        id={`equipmentConfig.${index}.configValue`}
                                        index={values.equipmentConfig[index].id}
                                        name={`equipmentConfig.${index}.configValue`}
                                        dataType={values.equipmentConfig[index].valueDatatype}
                                        data={values}
                                        disabled={
                                          isDisabled &&
                                          (values.equipmentConfig[index].configKey === "imposed_collection_by_cash_change_delivery" ||
                                            values.equipmentConfig[index].configKey === "imposed_collection")
                                        }

                                        value={values.equipmentConfig[index].configKey.startsWith('email') ? values.equipmentConfig[index].configValue.toLowerCase() : (values.equipmentConfig[index].configKey.startsWith('sequence') ? values.equipmentConfig[index].configValue.replace(/[^0-9,]/, '') : values.equipmentConfig[index].configValue)}
                                        placeholder={t('EQUIPMENT.CONFIG_VALUE')}
                                        onChange={(event) => {
                                          handleChange(event);

                                          let newValue = event.target.value;

                                          // Converte "true" ou "1" para booleano verdadeiro e qualquer outro valor para falso
                                          const booleanValue = newValue === "true" || newValue === "1";

                                          if (values.equipmentConfig[index].configKey === "imposed_collection_by_cash_change_delivery") {
                                            setImposedCollectionValue(booleanValue);
                                          }

                                          // 🔥 Nova regra: Verificar condição para abrir o modal
                                          if (values.equipmentConfig[index].configKey === "days_without_collect_by_cash_change_delivery") {
                                            let numericValue = parseInt(newValue, 10); // Converte para número

                                            if (numericValue < 30) {
                                              // Busca os valores dos outros campos
                                              const equipmentChangeRequired = values.equipmentConfig.find(
                                                (config) => config.configKey === "equipment_change_required"
                                              )?.configValue === "false"; // Convertendo para booleano

                                              /*  const sequenceForSendingChangeEmails = values.equipmentConfig.find(
                                                 (config) => config.configKey === "sequence_for_sending_change_emails"
                                               )?.configValue; */

                                              // Verifica todas as condições antes de abrir o modal
                                              if (equipmentChangeRequired) {
                                                setShowModal(true); // Função para abrir o modal
                                              }
                                            }
                                          }
                                        }}

                                        handleChangeDate={handleChangeDate}
                                        handleChangeDateTime={handleChangeDateTime}
                                        handleChangeDateRange={handleChangeDateRange}
                                        handleChangeNumber={handleChangeNumber}
                                        handleChangeNumberRange={handleChangeNumberRange}
                                        handleChangeMoneyRange={handleChangeMoneyRange}
                                        handleChangeMoney={handleChangeMoney}
                                        type='text'
                                        label={t('EQUIPMENT.CONFIG_VALUE')}
                                        labelRangeMin={t('FILTER.CONFIG_VALUE_MIN')}
                                        labelRangeMax={t('FILTER.CONFIG_VALUE_MAX')}
                                        isRange={values.equipmentConfig[index].isRange}
                                        configKey={values.equipmentConfig[index].configKey}
                                        configValue={values.equipmentConfig[index].configValue} // Passando configValue
                                      />
                                    </Form.Floating>
                                  </Form.Group>
                                </Col>

                                <Col xs={12} sm={6} md={6} lg={2} className="mb-4">
                                  <Form.Group>
                                    <Form.Floating>
                                      <ColorPicker
                                        color={values.equipmentConfig[index].color}
                                        handleChangeColor={handleChangeColor}
                                        data={values}
                                        index={values.equipmentConfig[index].id}
                                      />
                                    </Form.Floating>
                                  </Form.Group>
                                </Col>
                              </Row>
                            )))}
                      </div>)}
                  />
                </Row>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};
